document.addEventListener('DOMContentLoaded', () => {
  const arrowLinks = document.querySelectorAll('.arrow-link')

  if(arrowLinks) {
    if(navigator.platform.toLowerCase().indexOf('win') > -1) {
      arrowLinks.forEach(arrowLink => {
        arrowLink.classList.add('arrow-link--windows')
      })
    }
  }
})
